import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import {Message, Transition} from 'semantic-ui-react';

import {clearErrors, removeError} from 'state/actions';
import {getErrors} from 'state/selectors';

import styles from './ErrorContainer.module.scss';

export default function ErrorContainer() {
  const dispatch = useDispatch();
  const history = useHistory();
  const errors = useSelector(getErrors);
  const container = useRef(null);

  useEffect(() => {
    // clear all the errors once the user navigates to a different page
    return history.listen(() => {
      dispatch(clearErrors());
    });
  }, [dispatch, history]);

  return (
    <div ref={container} className={styles.ErrorContainer}>
      {[...errors].reverse().map(err => (
        <Transition
          key={err.id}
          closeOnDocumentClick={false}
          mountNode={container.current}
          duration={500}
          transitionOnMount
          open
        >
          <Message
            key={err.id}
            header="Error occurred"
            content={err.error}
            onDismiss={() => dispatch(removeError(err.id))}
            error
          />
        </Transition>
      ))}
    </div>
  );
}
